import {
  CreationTaxIdentifierSchema,
  RedactedTaxIdentifierSchema,
} from "@redotech/redo-model/outbound-labels/customs";
import * as z from "zod";

export const createTaxIdentifier = {
  name: "createTaxIdentifier" as const,
  input: z.object({ identifier: CreationTaxIdentifierSchema }),
  output: z.object({ identifiers: z.array(RedactedTaxIdentifierSchema) }),
};
